import { render } from "./DocumentActionsBar.vue?vue&type=template&id=7ea35866&scoped=true"
import script from "./DocumentActionsBar.vue?vue&type=script&lang=js"
export * from "./DocumentActionsBar.vue?vue&type=script&lang=js"

import "./DocumentActionsBar.vue?vue&type=style&index=0&id=7ea35866&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea35866"]])

export default __exports__